import {
  confidence,
  CURRENT_CONFIDENCE_FLAG,
  getVariant,
} from "@helpers/confidence"
import getSubscriptionStatus from "@helpers/getSubscriptionStatus"
import { getSession } from "@helpers/supabase"
import { redirect } from "react-router-dom"

export default async function onboardingLoader() {
  const signedInUsersRedirect = await redirectSignedInUsers()
  if (signedInUsersRedirect) return signedInUsersRedirect

  const onboardingVariantRedirect = await redirectToOnboardingVariant()
  if (onboardingVariantRedirect) return onboardingVariantRedirect

  return null
}

async function redirectSignedInUsers() {
  const { data } = await getSession()

  const userId = data?.session?.user?.id

  if (userId) {
    const subscriptionStatus = await getSubscriptionStatus(userId)

    if (subscriptionStatus === "active") {
      return redirect("/account/subscription")
    } else {
      return redirect("/checkout/plans")
    }
  }
}

async function redirectToOnboardingVariant() {
  // NOTE: `return null` if no Confidence flag handling is needed for the onboarding.
  return null

  const flag = await confidence.getFlag(CURRENT_CONFIDENCE_FLAG, {
    variant: "baseline",
  })

  const variant = getVariant(flag)

  switch (variant) {
    case "v1":
      return redirect(`/onboarding/v1${window.location.search}`)
    case "v2":
      return redirect(`/onboarding/v2${window.location.search}`)
    default:
      return null
  }
}
